import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { clienteConfigService } from '../../../services/planTrabajoService';
import { supabase } from '../../../lib/supabase';

// Paleta de 10 colores solicitados
const CLIENT_COLORS = [
  { value: '#3B82F6', label: 'Azul',     emoji: '🔵' },
  { value: '#22C55E', label: 'Verde',    emoji: '🟢' },
  { value: '#A855F7', label: 'Morado',   emoji: '🟣' },
  { value: '#EAB308', label: 'Amarillo', emoji: '🟡' },
  { value: '#F97316', label: 'Naranja',  emoji: '🟠' },
  { value: '#EF4444', label: 'Rojo',     emoji: '🔴' },
  { value: '#EC4899', label: 'Rosa',     emoji: '🩷' },
  { value: '#14B8A6', label: 'Turquesa', emoji: '🩵' },
  { value: '#06B6D4', label: 'Celeste',  emoji: '💙' },
  { value: '#6B7280', label: 'Gris',     emoji: '⚪' },
];

const DIAS_SEMANA = [
  { value: 1, label: 'Lunes' },
  { value: 2, label: 'Martes' },
  { value: 3, label: 'Miércoles' },
  { value: 4, label: 'Jueves' },
  { value: 5, label: 'Viernes' },
  { value: 6, label: 'Sábado' },
  // NO domingo
];

const FORMATOS = [
  { value: 'ENTERO', label: 'Entero' },
  { value: '50G',    label: '50 g' },
  { value: '100G',   label: '100 g' },
  { value: '500G',   label: '500 g' },
  { value: '1KG',    label: '1 kg' },
];

const TIPOS_CORTE = [
  { value: 'NORMAL',           label: 'Normal' },
  { value: 'EMPLATADO',        label: 'Emplatado' },
  { value: 'PALETILLA',        label: 'Paletilla' },
  { value: 'GRANDE_EMPLATADO', label: 'Grande y emplatado' },
];

const inputCls = 'w-full bg-[#0A0A0A] border border-white/10 text-white/85 text-sm rounded-lg px-3 py-2.5 font-oranienbaum placeholder-white/25 focus:outline-none focus:border-[#D6EF4E]/40 transition-colors';
const labelCls = 'block text-white/60 text-xs font-oranienbaum mb-2 uppercase tracking-wide font-semibold';
const sectionCls = 'bg-[#111111] rounded-xl border border-white/8 p-5 space-y-4';

const BigToggle = ({ checked, onChange, label, description, emoji, activeColor = '#D6EF4E' }) => (
  <button
    type="button"
    onClick={onChange}
    className="w-full flex items-center justify-between p-4 rounded-xl border transition-all text-left"
    style={{
      background: checked ? `${activeColor}10` : 'rgba(255,255,255,0.02)',
      borderColor: checked ? `${activeColor}40` : 'rgba(255,255,255,0.08)',
    }}
  >
    <div className="flex items-center gap-3">
      <span className="text-2xl">{emoji}</span>
      <div>
        <p className="font-oranienbaum font-semibold text-sm" style={{ color: checked ? activeColor : 'rgba(255,255,255,0.7)' }}>
          {label}
        </p>
        {description && <p className="text-white/30 text-[11px] font-oranienbaum">{description}</p>}
      </div>
    </div>
    <div
      className="relative w-12 h-6 rounded-full transition-colors duration-200 flex-shrink-0"
      style={{ background: checked ? activeColor : 'rgba(255,255,255,0.15)' }}
    >
      <span
        className="absolute top-1 w-4 h-4 rounded-full bg-[#111111] transition-all duration-200"
        style={{ left: checked ? '28px' : '4px' }}
      />
    </div>
  </button>
);

const CondicionesCortePanel = ({ clienteId, onSaved }) => {
  const [config, setConfig] = useState(null);
  const [productos, setProductos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(null);

  const [form, setForm] = useState({
    color: '',
    producto_id: '',
    tipo_corte: 'NORMAL',
    formato_corte: 'ENTERO',
    quiere_huesos: false,
    guardar_merma: false,
    recurrente: false,
    dia_semana: 1,
    cantidad_habitual: 1,
    empleado_preferente_id: '',
    observaciones_habituales: '',
    prioridad_habitual: 'NORMAL',
    frecuencia: 'SEMANAL',
    emplatado: false,
    guardar_recortes: false,
  });

  useEffect(() => {
    if (clienteId) loadData();
  }, [clienteId]);

  const loadData = async () => {
    setLoading(true);
    setError(null);
    try {
      const [configData, prodsResult, empsResult] = await Promise.all([
        clienteConfigService?.getByCliente(clienteId),
        supabase?.from('productos')?.select('id, nombre')?.eq('activo', true)?.order('nombre'),
        supabase?.from('empleados')?.select('id, nombre')?.eq('activo', true)?.order('nombre'),
      ]);
      setProductos(prodsResult?.data || []);
      setEmpleados(empsResult?.data || []);
      if (configData) {
        setConfig(configData);
        setForm({
          color: configData?.color || '',
          producto_id: configData?.producto_id || '',
          tipo_corte: configData?.tipo_corte || 'NORMAL',
          formato_corte: configData?.formato_corte || 'ENTERO',
          quiere_huesos: configData?.quiere_huesos || false,
          guardar_merma: configData?.guardar_merma || false,
          recurrente: configData?.recurrente || false,
          dia_semana: configData?.dia_semana || 1,
          cantidad_habitual: configData?.cantidad_habitual || 1,
          empleado_preferente_id: configData?.empleado_preferente_id || '',
          observaciones_habituales: configData?.observaciones_habituales || configData?.observaciones || '',
          prioridad_habitual: configData?.prioridad_habitual || 'NORMAL',
          frecuencia: configData?.frecuencia || 'SEMANAL',
          emplatado: configData?.emplatado || false,
          guardar_recortes: configData?.guardar_recortes || false,
        });
      }
    } catch (err) {
      console.error('[CondicionesCortePanel.loadData]', err);
      setError('Error al cargar la configuración');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setSaved(false);
  };

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const payload = {
        ...(config?.id ? { id: config?.id } : {}),
        cliente_id: clienteId,
        color: form?.color || null,
        producto_id: form?.producto_id || null,
        tipo_corte: form?.tipo_corte,
        formato_corte: form?.formato_corte,
        quiere_huesos: form?.quiere_huesos,
        guardar_merma: form?.guardar_merma,
        recurrente: form?.recurrente,
        dia_semana: form?.dia_semana,
        cantidad_habitual: form?.cantidad_habitual,
        empleado_preferente_id: form?.empleado_preferente_id || null,
        observaciones_habituales: form?.observaciones_habituales || null,
        observaciones: form?.observaciones_habituales || null,
        prioridad_habitual: form?.prioridad_habitual,
        frecuencia: form?.frecuencia,
        emplatado: form?.emplatado,
        guardar_recortes: form?.guardar_recortes,
      };
      const result = await clienteConfigService?.upsert(payload);
      setConfig(result);
      setSaved(true);
      onSaved?.();
      setTimeout(() => setSaved(false), 3000);
    } catch (err) {
      console.error('[CondicionesCortePanel.handleSave]', err);
      setError(err?.message || 'Error al guardar la configuración');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="w-6 h-6 border-2 border-white/10 border-t-[#D6EF4E] rounded-full animate-spin" />
      </div>
    );
  }

  const selectedColorObj = CLIENT_COLORS?.find(c => c?.value?.toLowerCase() === form?.color?.toLowerCase());
  const isCustomColor = form?.color && !selectedColorObj;

  return (
    <div className="space-y-5">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-oranienbaum font-bold text-white text-lg">Condiciones de Corte</h3>
          <p className="text-white/40 text-xs font-oranienbaum mt-0.5">
            Configura una vez · Se hereda automáticamente en nuevos trabajos del Plan de Trabajo
          </p>
        </div>
        {config && (
          <span className="text-[10px] text-[#D6EF4E]/70 font-oranienbaum bg-[#D6EF4E]/8 px-2.5 py-1 rounded-full border border-[#D6EF4E]/20">
            ✓ Configurado
          </span>
        )}
      </div>

      {error && (
        <div className="p-3 bg-red-500/10 border border-red-500/30 rounded-lg flex items-center gap-2">
          <Icon name="AlertCircle" size={14} color="#EF4444" />
          <span className="text-red-400 text-xs font-oranienbaum">{error}</span>
          <button onClick={() => setError(null)} className="ml-auto text-red-400/60 hover:text-red-400">
            <Icon name="X" size={12} />
          </button>
        </div>
      )}

      {/* ── 1. COLOR DEL CLIENTE ─────────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>1. Color del cliente</label>
        <p className="text-white/30 text-[11px] font-oranienbaum -mt-2">
          Identifica visualmente al cliente en todas las vistas del Plan de Trabajo
        </p>

        {/* Preview del color seleccionado */}
        {form?.color && (
          <div
            className="flex items-center gap-3 p-3 rounded-xl border"
            style={{ background: `${form?.color}18`, borderColor: `${form?.color}40` }}
          >
            <div className="w-10 h-10 rounded-xl flex-shrink-0 shadow-lg" style={{ background: form?.color }} />
            <div>
              <p className="text-white text-sm font-oranienbaum font-semibold">
                {selectedColorObj ? `${selectedColorObj?.emoji} ${selectedColorObj?.label}` : 'Color personalizado'}
              </p>
              <p className="text-white/40 text-[10px] font-oranienbaum">{form?.color}</p>
            </div>
            <button
              onClick={() => handleChange('color', '')}
              className="ml-auto text-white/30 hover:text-white/60 transition-colors p-1"
              title="Quitar color"
            >
              <Icon name="X" size={14} />
            </button>
          </div>
        )}

        {/* Paleta de colores — círculos grandes clicables */}
        <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
          {CLIENT_COLORS?.map(c => {
            const isSelected = form?.color?.toLowerCase() === c?.value?.toLowerCase();
            return (
              <button
                key={c?.value}
                type="button"
                onClick={() => handleChange('color', c?.value)}
                className="flex flex-col items-center gap-2 p-3 rounded-xl border transition-all focus:outline-none"
                style={{
                  borderColor: isSelected ? c?.value : 'rgba(255,255,255,0.08)',
                  background: isSelected ? `${c?.value}22` : 'rgba(255,255,255,0.02)',
                  transform: isSelected ? 'scale(1.06)' : 'scale(1)',
                  boxShadow: isSelected ? `0 0 0 2px ${c?.value}50, 0 4px 12px ${c?.value}30` : 'none',
                }}
                title={c?.label}
              >
                <div
                  className="w-12 h-12 rounded-full shadow-lg flex items-center justify-center"
                  style={{ background: c?.value }}
                >
                  {isSelected && (
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8l3.5 3.5L13 4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  )}
                </div>
                <span className="text-[10px] text-white/60 font-oranienbaum leading-tight text-center">
                  {c?.emoji} {c?.label}
                </span>
              </button>
            );
          })}
        </div>

        {/* Color personalizado */}
        <div className="flex items-center gap-3 p-3 rounded-xl border border-white/8 bg-white/2">
          <input
            type="color"
            value={form?.color || '#6B7280'}
            onChange={e => handleChange('color', e?.target?.value)}
            className="w-12 h-12 rounded-xl border border-white/10 bg-transparent cursor-pointer flex-shrink-0"
            title="Color personalizado"
          />
          <div>
            <p className="text-white/70 text-sm font-oranienbaum font-medium">Color personalizado</p>
            <p className="text-white/30 text-[10px] font-oranienbaum">Haz clic para elegir cualquier color</p>
          </div>
          {isCustomColor && (
            <span className="ml-auto text-[10px] text-[#D6EF4E]/70 font-oranienbaum bg-[#D6EF4E]/10 px-2 py-0.5 rounded-full border border-[#D6EF4E]/20">
              ✓ Activo
            </span>
          )}
        </div>
      </div>

      {/* ── 2. PRODUCTO HABITUAL ─────────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>2. Producto habitual</label>
        <select
          value={form?.producto_id || ''}
          onChange={e => handleChange('producto_id', e?.target?.value)}
          className={inputCls}
          style={{ colorScheme: 'dark' }}
        >
          <option value="">Sin producto habitual</option>
          {productos?.map(p => (
            <option key={p?.id} value={p?.id}>{p?.nombre}</option>
          ))}
        </select>
      </div>

      {/* ── 3. TIPO DE CORTE HABITUAL ────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>3. Tipo de corte habitual</label>
        <div className="grid grid-cols-2 gap-2">
          {TIPOS_CORTE?.map(t => (
            <button
              key={t?.value}
              type="button"
              onClick={() => handleChange('tipo_corte', t?.value)}
              className={`py-2.5 px-3 rounded-lg text-sm font-oranienbaum border transition-colors text-left ${
                form?.tipo_corte === t?.value
                  ? 'bg-[#D6EF4E]/15 border-[#D6EF4E]/40 text-[#D6EF4E]'
                  : 'border-white/10 text-white/50 hover:border-white/20 hover:text-white/70'
              }`}
            >
              {t?.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── 4. FORMATO HABITUAL ──────────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>4. Formato habitual</label>
        <div className="flex gap-2 flex-wrap">
          {FORMATOS?.map(f => (
            <button
              key={f?.value}
              type="button"
              onClick={() => handleChange('formato_corte', f?.value)}
              className={`px-4 py-2.5 rounded-lg text-sm font-oranienbaum border transition-colors ${
                (form?.formato_corte || 'ENTERO') === f?.value
                  ? 'bg-[#D6EF4E]/15 border-[#D6EF4E]/40 text-[#D6EF4E]' :'border-white/10 text-white/50 hover:border-white/20 hover:text-white/70'
              }`}
            >
              {f?.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── 5. OPCIONES HABITUALES ───────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>5. Opciones habituales</label>
        <div className="space-y-3">
          <BigToggle
            checked={form?.quiere_huesos}
            onChange={() => handleChange('quiere_huesos', !form?.quiere_huesos)}
            label="Quiere huesos"
            description="El cliente desea conservar los huesos"
            emoji="🦴"
            activeColor="#F59E0B"
          />
          <BigToggle
            checked={form?.guardar_merma}
            onChange={() => handleChange('guardar_merma', !form?.guardar_merma)}
            label="Guardar merma"
            description="El cliente desea conservar la merma"
            emoji="♻️"
            activeColor="#22C55E"
          />
        </div>
      </div>

      {/* ── 6. PLANIFICACIÓN HABITUAL ────────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>6. Planificación habitual</label>

        {/* Tipo: Puntual / Recurrente */}
        <div>
          <p className="text-white/40 text-[11px] font-oranienbaum mb-2">Tipo</p>
          <div className="flex gap-2">
            {[{ v: false, l: 'Puntual' }, { v: true, l: 'Recurrente' }]?.map(({ v, l }) => (
              <button
                key={l}
                type="button"
                onClick={() => handleChange('recurrente', v)}
                className={`flex-1 py-2.5 rounded-lg text-sm font-oranienbaum border transition-colors ${
                  form?.recurrente === v
                    ? 'bg-[#D6EF4E]/15 border-[#D6EF4E]/40 text-[#D6EF4E]'
                    : 'border-white/10 text-white/50 hover:border-white/20'
                }`}
              >
                {l}
              </button>
            ))}
          </div>
        </div>

        {/* Día habitual (solo si recurrente) */}
        {form?.recurrente && (
          <div>
            <p className="text-white/40 text-[11px] font-oranienbaum mb-2">Día habitual</p>
            <div className="grid grid-cols-3 gap-2">
              {DIAS_SEMANA?.map(d => (
                <button
                  key={d?.value}
                  type="button"
                  onClick={() => handleChange('dia_semana', d?.value)}
                  className={`py-2 rounded-lg text-xs font-oranienbaum border transition-colors ${
                    form?.dia_semana === d?.value
                      ? 'bg-[#D6EF4E]/15 border-[#D6EF4E]/40 text-[#D6EF4E]'
                      : 'border-white/10 text-white/50 hover:border-white/20'
                  }`}
                >
                  {d?.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Cantidad habitual */}
        <div>
          <p className="text-white/40 text-[11px] font-oranienbaum mb-2">Cantidad habitual de piezas</p>
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => handleChange('cantidad_habitual', Math.max(1, (form?.cantidad_habitual || 1) - 1))}
              className="w-12 h-12 rounded-xl bg-white/8 text-white/70 hover:bg-white/15 font-bold text-xl transition-colors border border-white/10"
            >−</button>
            <span className="text-white font-oranienbaum font-bold text-3xl w-12 text-center">{form?.cantidad_habitual || 1}</span>
            <button
              type="button"
              onClick={() => handleChange('cantidad_habitual', (form?.cantidad_habitual || 1) + 1)}
              className="w-12 h-12 rounded-xl bg-white/8 text-white/70 hover:bg-white/15 font-bold text-xl transition-colors border border-white/10"
            >+</button>
          </div>
        </div>

        {/* Empleado habitual */}
        <div>
          <p className="text-white/40 text-[11px] font-oranienbaum mb-2">Empleado habitual</p>
          <select
            value={form?.empleado_preferente_id || ''}
            onChange={e => handleChange('empleado_preferente_id', e?.target?.value)}
            className={inputCls}
            style={{ colorScheme: 'dark' }}
          >
            <option value="">Sin asignar</option>
            {empleados?.map(e => (
              <option key={e?.id} value={e?.id}>{e?.nombre}</option>
            ))}
          </select>
        </div>
      </div>

      {/* ── 7. OBSERVACIONES HABITUALES ──────────────────────────────── */}
      <div className={sectionCls}>
        <label className={labelCls}>7. Observaciones / Instrucciones habituales</label>
        <p className="text-white/30 text-[11px] font-oranienbaum -mt-2">
          Ej: separar puntas · huesos cortados · entregar antes de las 13:00 · paquetes especialmente finos
        </p>
        <textarea
          value={form?.observaciones_habituales || ''}
          onChange={e => handleChange('observaciones_habituales', e?.target?.value)}
          rows={3}
          placeholder="Instrucciones habituales para este cliente..."
          className={`${inputCls} resize-none`}
        />
      </div>

      {/* ── 8. GUARDAR ───────────────────────────────────────────────── */}
      <button
        onClick={handleSave}
        disabled={saving}
        className="w-full py-4 rounded-xl font-oranienbaum font-bold text-base transition-all disabled:opacity-50 flex items-center justify-center gap-2"
        style={{ background: saved ? '#22C55E' : '#D6EF4E', color: '#111111' }}
      >
        {saving ? (
          <>
            <div className="w-4 h-4 border-2 border-black/30 border-t-black rounded-full animate-spin" />
            Guardando...
          </>
        ) : saved ? (
          <>✓ Condiciones guardadas</>
        ) : (
          <>💾 GUARDAR CONDICIONES</>
        )}
      </button>
    </div>
  );
};

export default CondicionesCortePanel;
